export default "7,Tidlig høstvinterbeite\n8,Spredt brukte høstvinterbeiter\n"